import React from "react";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../../../firebase";
import { Button } from "../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { ClientFile } from "@visitproof/types";
import { useChild } from "../../../contexts/ChildContext";
import { useDeleteAlert } from "../../../contexts/DeleteAlertProvider";

type File = ClientFile;

interface DeleteFileButtonProps {
  childId: string;
  file: File;
}

const DeleteChildFileButton: React.FC<DeleteFileButtonProps> = ({
  childId,
  file,
}) => {
  const { deleteFileFromChild } = useChild();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    const fileRef = ref(storage, file.path);
    await deleteObject(fileRef);
    await deleteFileFromChild(childId, id);
  };

  const handleClick = () => {
    openAlert(
      file,
      {
        displayName: "file",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteChildFileButton;
